{
  "back": "Back",
  "gate": { "title": "Not available yet", "description": "The staff area isn't open yet." },
  "missing": { "title": "Staff not found", "description": "This chief isn't on your team." },
  "roles": { "training": "Sports Director", "scouting": "Chief Scout", "medical": "Team Doctor", "academy": "Academy Director", "commercial": "Commercial Director" },
  "hero": { "tierLabel": "Tier", "salaryLabel": "Salary", "salary": "{amount} CZ$/season", "ratingEyebrow": "Rating /99", "specHeadline": "Best at {axis}", "photoFallback": "Photo" },
  "tabs": { "overview": "Overview", "effect": "Effect", "history": "History" },
  "columns": {
    "dimensions": "Coaching", "levels": "Coaching group focus", "roleSkills": "Role skills",
    "levelsTooltip": "U23 covers Academy riders and young pros up to 25; Senior covers riders 26 and up. A chief's coaching group focus shows which age group they train best, on top of their coaching dimensions."
  },
  "axes": {
    "physical": "physical training", "mental": "mental training", "technical": "technical training",
    "u23": "U23", "senior": "senior",
    "evaluation": "talent evaluation", "reach": "network reach",
    "recovery": "recovery", "injuryPrevention": "injury prevention",
    "intake": "intake quality", "growth": "growth rate",
    "negotiation": "negotiation", "marketing": "marketing"
  },
  "effect": { "body": "This chief's overall rating ({rating}) drives how much of the facility's effect is realised. The Training Center is active in-game today; the others are coming soon and show what they will do once they go live." },
  "history": {
    "body": "Contract history and tenure will appear here once staff contracts land.",
    "scouting": {
      "loading": "Loading scouting history…",
      "loadFailed": "Couldn't load scouting history. Try again.",
      "empty": "No scouted riders yet.",
      "loadingRider": "Loading rider…",
      "riderUnavailable": "Rider no longer available",
      "levelValue": "Level {level}/{max}",
      "table": { "date": "Date", "rider": "Rider", "level": "Level" }
    }
  },
  "switcher": { "count": "{index} / {total}" },
  "public": {
    "team": "Employed by {team}",
    "viewTeam": "View team",
    "limitedNote": "This is another manager's staff, so only rating and top specialization are visible. The full ability breakdown is only shown to the owning team."
  },
  "release": {
    "button": "Release staff",
    "title": "Release {name}?",
    "body": "The contract ends immediately. You'll pay severance now, and the role is open for a new hire right away.",
    "severanceLabel": "Severance ({multiplier} × {weeklyWage} CZ$)",
    "wagesFreedLabel": "Weekly wages freed up",
    "slotLabel": "{role} slot",
    "slotValue": "Open immediately",
    "keepButton": "Keep him/her",
    "confirmButton": "Release for {amount} CZ$",
    "confirmBusy": "Releasing…",
    "errors": {
      "staff_not_found": "This staff member isn't on your team anymore.",
      "already_released": "Already released.",
      "insufficient_funds": "You can't afford the severance ({amount} CZ$).",
      "insufficient_available_balance": "Not enough available money: part of your balance is locked in auction bids.",
      "facilities_disabled": "Staff management isn't available yet.",
      "auth": "You need to be signed in to do that.",
      "network": "Connection failed. Try again in a moment.",
      "failed": "Couldn't release this staff member. Try again in a moment."
    }
  }
}
